import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "workflow-history-reset",
  "use": "workflow-history-reset-usage",
  "viewBox": "0 0 22 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 22 23\" id=\"workflow-history-reset\"><path stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M1 11.543a10 10 0 1 0 10-10 10.83 10.83 0 0 0-7.489 3.044L1 7.098m0 0V1.543m0 5.555h5.556\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol